(ns minorodata.webhooks.api
  (:require
   [clojure.string]
   [minorodata.webhooks.model :refer [->webhook ->webhook-trigger]]
   [mold-http.core :refer [reg-event-http]]
   [re-posh.core :as re-posh]))

;;;;
;; Triggers
;;;;

(defn create-trigger-request [_ [{:keys [action-type params]}]]
  {:http-xhrio
   {:method    :post
    :url       (str "/api/trigger")
    :params    {:action-type action-type
                :params      params}}})

(defn create-trigger-callback [_ [error]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to create webhook trigger"]}
    {:dispatch [:webhooks.api/fetch-triggers]}))

(reg-event-http
 :webhooks.api/create-trigger
 create-trigger-request
 create-trigger-callback)

(defn fetch-triggers-request []
  {:http-xhrio
   {:method    :get
    :url       "/api/trigger"}})

(defn fetch-triggers-callback [_ [error results]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to fetch webhook triggers"]}
    {:dispatch [:webhook-trigger/add-many (mapv ->webhook-trigger results)]}))

(reg-event-http
 :webhooks.api/fetch-triggers
 fetch-triggers-request
 fetch-triggers-callback)

(defn delete-trigger-request [_ [{:keys [trigger-id]}]]
  {:http-xhrio
   {:method :delete
    :url    "/api/trigger"
    :params {:trigger-id trigger-id}
    :cb-params {:trigger-id trigger-id}}})

(defn delete-trigger-callback [_ [error _ {:keys [trigger-id]}]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to delete trigger"]}
    {:dispatch [:webhook-trigger/delete [:webhook-trigger/trigger-id trigger-id]]}))

(reg-event-http
 :webhooks.api/delete-trigger
 delete-trigger-request
 delete-trigger-callback)


;;;;
;; Webhooks
;;;;

(defn create-webhook-request [_ [{:keys [transform-master-id event-type trigger on-success]}]]
  {:http-xhrio
   {:method    :post
    :url       "/api/webhooks"
    :params    {:transform-master-id transform-master-id
                :event-type          event-type
                :triggers            [trigger]}
    :cb-params {:transform-master-id transform-master-id
                :on-success on-success}}})

(defn create-webhook-callback [_ [error _ {:keys [transform-master-id on-success]}]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to create webhook"]}
    (do
      (when on-success (on-success))
      {:dispatch-n [[:webhooks.api/fetch-transform-webhooks {:master-id transform-master-id}]
                    [:webhooks.api/fetch-triggers]]})))

(reg-event-http
 :webhooks.api/create-webhook
 create-webhook-request
 create-webhook-callback)


(defn fetch-transform-webhooks-request [_ [{:keys [master-id]}]]
  {:http-xhrio
   {:method    :get
    :url       "/api/webhooks"
    :params    {:transform-master-id master-id}}})

(defn fetch-transform-webhooks-callback [_ [error results]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to fetch transform webhooks"]}
    {:dispatch [:webhook/add-many (mapv ->webhook results)]}))

(reg-event-http
 :webhooks.api/fetch-transform-webhooks
 fetch-transform-webhooks-request
 fetch-transform-webhooks-callback)

(defn delete-webhook-request [_ [{:keys [hook-id]}]]
  {:http-xhrio
   {:method :delete
    :url    "/api/webhooks"
    :params {:webhook-id hook-id}
    :cb-params {:hook-id hook-id}}})

(defn delete-webhook-callback [_ [error _ {:keys [hook-id]}]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to delete webhook"]}
    {:dispatch [:webhook/delete [:webhook/hook-id hook-id]]}))

(reg-event-http
 :webhooks.api/delete-webhook
 delete-webhook-request
 delete-webhook-callback)

(defn create-webhook-trigger-request [_ [{:keys [hook-id transform-master-id trigger on-success]}]]
  {:http-xhrio
   {:method    :post
    :url       "/api/webhooks/triggers"
    :params    {:webhook-id hook-id
                :triggers   [trigger]}
    :cb-params {:transform-master-id transform-master-id
                :on-success on-success}}})

(defn create-webhook-trigger-callback [_ [error _ {:keys [transform-master-id on-success]}]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to create webhook"]}
    (do
      (when on-success (on-success))
      {:dispatch-n [[:webhooks.api/fetch-transform-webhooks {:master-id transform-master-id}]
                    [:webhooks.api/fetch-triggers]]})))

(reg-event-http
 :webhooks.api/create-webhook-trigger
 create-webhook-trigger-request
 create-webhook-trigger-callback)

(defn delete-webhook-trigger-request [_ [{:keys [hook-id trigger-id]}]]
  {:http-xhrio
   {:method :delete
    :url    "/api/webhooks/triggers"
    :params {:webhook-id hook-id
             :trigger-id trigger-id}
    :cb-params {:hook-id    hook-id
                :trigger-id trigger-id}}})

(defn delete-webhook-trigger-callback [_ [error _ {:keys [hook-id trigger-id]}]]
  (let [master-id (-> @(re-posh/subscribe [:webhook/pull [:webhook/hook-id hook-id]])
                      :webhook/source-master-id)]
    (if (some? error)
      {:dispatch [:app.events/add-snack :error "Failed to delete webhook"]}
      {:dispatch-n [[:webhooks.api/fetch-transform-webhooks {:master-id master-id}]
                    [:webhooks.api/fetch-triggers]]})))

(reg-event-http
 :webhooks.api/delete-webhook-trigger
 delete-webhook-trigger-request
 delete-webhook-trigger-callback)
